// extracted by mini-css-extract-plugin
export default {"PdfPages":"UjMeJ","pdfPagesHeader":"HiaEs","pdfPagesCloseBtn":"HbPP6","pdfThumbnail":"nHJwv"};